// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Automações (Importações) — mesmo visual da tela Importadores:
   navy #18316e/#0f2047, superfícies brancas, fundo #f5f7fa, título Abhaya Libre. */

.styles_container__u\\+rsk {
  margin: 0 2rem;
  padding: 1rem;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.styles_header__xA2Z3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.styles_title__9oKHR {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1 1;
}

.styles_titleText__MvYt7 {
  color: #18316e;
  font-family: "Abhaya Libre", serif;
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
  padding: 0;
}

.styles_subtitle__D6Ekg {
  color: #6b6e76;
  font-size: 0.85rem;
  margin: 2px 0 0;
}

.styles_headerActions__Qq1uq {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

/* ===== stat-cards (Concluído / Erro / Pendente) ===== */
.styles_statCards__T96Xa {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.styles_statCard__mc981 {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-left-width: 4px;
  border-radius: 10px;
  padding: 8px 16px 8px 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.styles_statNum__CqmOE {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex: none;
  display: grid;
  place-items: center;
  color: #fff;
  font-weight: 700;
  font-size: 13px;
}
.styles_statLabel__cllb6 {
  font-size: 13.5px;
  font-weight: 600;
  color: #3a3d45;
}

/* ===== filtros ===== */
.styles_filtrosCard__nnFUc {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  overflow: hidden;
}
.styles_filtrosHeader__3vDX9 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
  color: #0d2847;
  font-weight: 600;
}
.styles_iconFilter__XV1V9 {
  color: #1e4a7a;
  font-size: 1.5rem;
}
.styles_filtrosGrid__qgqvP {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: flex-start;
}
.styles_filtrosAcoes__6Iafx {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

/* ===== tabela ===== */
.styles_tableCard__7IdCU {
  background: white;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.styles_tableCard__7IdCU table {
  width: 100%;
}
.styles_tableCard__7IdCU th {
  background-color: #f5f7fa;
  color: #0d2847;
  font-weight: 600;
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
}
.styles_tableCard__7IdCU td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: middle;
}
.styles_tableCard__7IdCU tr:hover td {
  background-color: #f9f9f9;
}
.styles_thSort__q1tj\\+ {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.styles_tableFooter__sI90w {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.5rem;
}
.styles_total__m8Zv8 {
  font-size: 12.5px;
  font-weight: 600;
  color: #18316e;
}
.styles_vazio__lwKyi {
  text-align: center;
  color: #6b6e76;
  padding: 40px 16px;
}

/* ===== modais ===== */
.styles_reqHint__9Y3is {
  font-size: 12px;
  color: #6b6e76;
  margin: 0 0 8px;
}
.styles_reqRotulo__nMjIn {
  font-weight: 600;
}
.styles_resumoGrid__l0VKc {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem 2rem;
  margin-bottom: 1rem;
}
.styles_resumoItem__lmc5B {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.styles_resumoLabel__pAMZ9 {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6b6e76;
  font-weight: 700;
}
.styles_resumoValor__XmdRu {
  font-size: 13.5px;
  font-weight: 600;
  color: #212529;
}

@media (max-width: 1024px) {
  .styles_header__xA2Z3 {
    flex-direction: column;
    align-items: flex-start;
  }
}
@media (max-width: 768px) {
  .styles_container__u\\+rsk {
    margin: 0 1rem;
    padding: 0.5rem;
  }
  .styles_titleText__MvYt7 {
    font-size: 1.5rem;
  }
  .styles_tableCard__7IdCU {
    overflow-x: auto;
  }
  .styles_tableCard__7IdCU table {
    min-width: 800px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Automacoes/styles.module.css"],"names":[],"mappings":"AAAA;mFACmF;;AAEnF;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Automações (Importações) — mesmo visual da tela Importadores:\n   navy #18316e/#0f2047, superfícies brancas, fundo #f5f7fa, título Abhaya Libre. */\n\n.container {\n  margin: 0 2rem;\n  padding: 1rem;\n  background-color: #f5f7fa;\n  min-height: 100vh;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  flex: 1;\n}\n\n.titleText {\n  color: #18316e;\n  font-family: \"Abhaya Libre\", serif;\n  font-size: 2rem;\n  font-weight: 600;\n  margin: 0;\n  padding: 0;\n}\n\n.subtitle {\n  color: #6b6e76;\n  font-size: 0.85rem;\n  margin: 2px 0 0;\n}\n\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* ===== stat-cards (Concluído / Erro / Pendente) ===== */\n.statCards {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.statCard {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-left-width: 4px;\n  border-radius: 10px;\n  padding: 8px 16px 8px 12px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n.statNum {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  flex: none;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  font-weight: 700;\n  font-size: 13px;\n}\n.statLabel {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #3a3d45;\n}\n\n/* ===== filtros ===== */\n.filtrosCard {\n  background: white;\n  border-radius: 12px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-width: 100%;\n  overflow: hidden;\n}\n.filtrosHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n  color: #0d2847;\n  font-weight: 600;\n}\n.iconFilter {\n  color: #1e4a7a;\n  font-size: 1.5rem;\n}\n.filtrosGrid {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n.filtrosAcoes {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  margin-top: 1rem;\n}\n\n/* ===== tabela ===== */\n.tableCard {\n  background: white;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n.tableCard table {\n  width: 100%;\n}\n.tableCard th {\n  background-color: #f5f7fa;\n  color: #0d2847;\n  font-weight: 600;\n  padding: 0.75rem 1rem;\n  text-align: left;\n  border-bottom: 2px solid #e0e0e0;\n  white-space: nowrap;\n}\n.tableCard td {\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #e0e0e0;\n  vertical-align: middle;\n}\n.tableCard tr:hover td {\n  background-color: #f9f9f9;\n}\n.thSort {\n  cursor: pointer;\n  user-select: none;\n}\n.tableFooter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n.total {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #18316e;\n}\n.vazio {\n  text-align: center;\n  color: #6b6e76;\n  padding: 40px 16px;\n}\n\n/* ===== modais ===== */\n.reqHint {\n  font-size: 12px;\n  color: #6b6e76;\n  margin: 0 0 8px;\n}\n.reqRotulo {\n  font-weight: 600;\n}\n.resumoGrid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem 2rem;\n  margin-bottom: 1rem;\n}\n.resumoItem {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.resumoLabel {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #6b6e76;\n  font-weight: 700;\n}\n.resumoValor {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #212529;\n}\n\n@media (max-width: 1024px) {\n  .header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n@media (max-width: 768px) {\n  .container {\n    margin: 0 1rem;\n    padding: 0.5rem;\n  }\n  .titleText {\n    font-size: 1.5rem;\n  }\n  .tableCard {\n    overflow-x: auto;\n  }\n  .tableCard table {\n    min-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__u+rsk`,
	"header": `styles_header__xA2Z3`,
	"title": `styles_title__9oKHR`,
	"titleText": `styles_titleText__MvYt7`,
	"subtitle": `styles_subtitle__D6Ekg`,
	"headerActions": `styles_headerActions__Qq1uq`,
	"statCards": `styles_statCards__T96Xa`,
	"statCard": `styles_statCard__mc981`,
	"statNum": `styles_statNum__CqmOE`,
	"statLabel": `styles_statLabel__cllb6`,
	"filtrosCard": `styles_filtrosCard__nnFUc`,
	"filtrosHeader": `styles_filtrosHeader__3vDX9`,
	"iconFilter": `styles_iconFilter__XV1V9`,
	"filtrosGrid": `styles_filtrosGrid__qgqvP`,
	"filtrosAcoes": `styles_filtrosAcoes__6Iafx`,
	"tableCard": `styles_tableCard__7IdCU`,
	"thSort": `styles_thSort__q1tj+`,
	"tableFooter": `styles_tableFooter__sI90w`,
	"total": `styles_total__m8Zv8`,
	"vazio": `styles_vazio__lwKyi`,
	"reqHint": `styles_reqHint__9Y3is`,
	"reqRotulo": `styles_reqRotulo__nMjIn`,
	"resumoGrid": `styles_resumoGrid__l0VKc`,
	"resumoItem": `styles_resumoItem__lmc5B`,
	"resumoLabel": `styles_resumoLabel__pAMZ9`,
	"resumoValor": `styles_resumoValor__XmdRu`
};
export default ___CSS_LOADER_EXPORT___;
